const PartnerList = {
  "primary": [
   {"url": "http://www.aacvc.org", "title": "Anne Arundel Volunteer Center", "img": "aavc.jpg"},
   {"url": "http://www.aacc.edu", "title": "Anne Arundel Community College", "img": "aacc.jpg"},
   {"url": "https://www.annapolis.gov/371/Mayors-Office", "title": "Mayor Office of Annapolis", "img": "mayor.jpg"},
   {"url": "https://www.annapolis.gov/413/Police", "title": "Annapolis Police Department", "img": "police.jpg"},
   {"url": "https://www.kilwins.com/annapolis", "title": "Kilwin's Ice Cream", "img": "kilwins.png"},
   {"url": "http://www.hopeforall.us", "title": "Hope For All", "img": "hopeforall.png"},
   {"url": "http://www.s4sannapolis.org", "title": "Seeds 4 Success", "img": "seeds.jpg"}
  ], 
  "other": [
    "Anne Arundel Medical Center/ Abuse & Domestic Violence Program",
    "Department of Aging Anne Arundel County",
    "Annapolis City Church",
    "Samaritan House",
    "Annapolis Vet Center",
    "Anne Arundel County Council",
    "Annapolis City Council",
    "Anne Arundel County Office of Emergency Management",
    "Annapolis / Anne Arundel Fire Department",
    "Healthy Start Case Manager – Department of Health",
    "City of Annapolis Emergency Preparedness",
    "Opportunities Industrialization Center (OIC) of Anne Arundel County",
    "Anne Arundel County Attorney’s Office"
  ]
};

export {PartnerList};
